import React from "react";
import Layout from "components/layout";
import Register from "components/userAccount/register";

function index() {
  return (
    <Layout>
      <Register/>
    </Layout>
  );
}

export default index;
